import { useEffect } from "react";

import { ENV } from "../../../constants";



function Analytics() {
  const productionEnvs = [
    "prod",
    "production"
  ]

  useEffect(() => {
    // Run analytics only in production
    if (!productionEnvs.includes(ENV)) return;

    (function (c: any, l: Document, a: string, r: string, i: string, t?: HTMLScriptElement, y?: Node) {
      (c as any)[a] = (c as any)[a] || function () {
        ((c as any)[a].q = (c as any)[a].q || []).push(arguments);
      };
      t = l.createElement(r) as HTMLScriptElement;
      t.async = true;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y?.parentNode?.insertBefore(t, y);
    })(window, document, "clarity", "script", "qxrcic8hlj");
  }, []);

  return null;
}

export default Analytics;